import http from '@/assets/plugin/prototypes/modules/http.js'

//删除七牛云文件
export function deleteQiNiuFiles(data) {
  return http.post("basic/delete/file", data)
}



// WEBPACK FOOTER //
// ./src/api/basic.js